/**
 * Como a mãe anda pelo app.
 *
 * No celular: barra de baixo com o botão da Ruth no centro, elevado. No
 * notebook: menu lateral de 240px. É a mesma navegação, dois desenhos —
 * conforme docs/design/Main.dc.html e Desktop.dc.html.
 */

import { Icone, type NomeDeIcone } from './Icone'

export type Tela =
  | 'hoje'
  | 'semana'
  | 'ruth'
  | 'casa'
  | 'mais'
  | 'remedios'
  | 'compras'
  | 'compromissos'
  | 'config'

/** As telas de dentro de "Mais" acendem "Mais" na barra: a mãe sabe onde está. */
const DENTRO_DE_MAIS: Tela[] = ['remedios', 'compras', 'compromissos', 'config']

function acesa(aba: Tela, atual: Tela): boolean {
  return aba === atual || (aba === 'mais' && DENTRO_DE_MAIS.includes(atual))
}

type Props = {
  atual: Tela
  aoTrocar: (tela: Tela) => void
}

type Aba = { id: Tela; rotulo: string; icone: NomeDeIcone }

const ABAS: Aba[] = [
  { id: 'hoje', rotulo: 'Hoje', icone: 'casa' },
  { id: 'semana', rotulo: 'Semana', icone: 'calendario' },
  { id: 'ruth', rotulo: 'Ruth', icone: 'microfone' },
  { id: 'casa', rotulo: 'A casa', icone: 'protegido' },
  { id: 'mais', rotulo: 'Mais', icone: 'mais' },
]

export function BarraInferior({ atual, aoTrocar }: Props) {
  return (
    <nav className="barra" aria-label="Navegação">
      {ABAS.map((aba) =>
        aba.id === 'ruth' ? (
          <button
            key={aba.id}
            type="button"
            className="barra__item barra__ruth"
            aria-label="Falar com a Ruth"
            aria-current={acesa(aba.id, atual) ? 'page' : undefined}
            onClick={() => aoTrocar(aba.id)}
          >
            <span className="barra__botao-ruth">
              <Icone nome={aba.icone} tamanho={26} />
            </span>
            <span>{aba.rotulo}</span>
          </button>
        ) : (
          <button
            key={aba.id}
            type="button"
            className={`barra__item ${acesa(aba.id, atual) ? 'barra__item--ativo' : ''}`}
            aria-current={acesa(aba.id, atual) ? 'page' : undefined}
            onClick={() => aoTrocar(aba.id)}
          >
            <Icone nome={aba.icone} tamanho={22} />
            <span>{aba.rotulo}</span>
          </button>
        ),
      )}
    </nav>
  )
}

export function MenuLateral({ atual, aoTrocar }: Props) {
  return (
    <nav className="menu-lateral" aria-label="Navegação">
      <div className="menu-lateral__marca">
        <span className="menu-lateral__nome">Ruth</span>
        <span className="menu-lateral__hebraico" lang="he">
          רות
        </span>
      </div>
      {ABAS.map((aba) => (
        <button
          key={aba.id}
          type="button"
          className={`menu-lateral__item ${acesa(aba.id, atual) ? 'menu-lateral__item--ativo' : ''}`}
          aria-current={acesa(aba.id, atual) ? 'page' : undefined}
          onClick={() => aoTrocar(aba.id)}
        >
          <Icone nome={aba.icone} />
          <span>{aba.rotulo}</span>
        </button>
      ))}
    </nav>
  )
}
